import moment from 'moment'
import store from '../services/store'
import { bus, EVENTS } from '../services/bus/index.js'

function addOrUpdateCalendarEvent (event, type) {
  store.commit('removeCalendarEvent', { eventPk: event.pk, type })
  let date = moment(event.date)
  let key = date.format('DD/MM/YYYY')
  store.commit('addCalendarEvent', { event, key, type })
}

export const realtimeEvents = {
  deleteReminder: data => {
    bus.$emit(EVENTS.DELETE_REMINDER, data)
    store.commit('removeCalendarEvent', { eventPk: data.pk, type: 'reminders' })
  },
  editReminder: data => addOrUpdateCalendarEvent(data, 'reminders'),
  updateReminder: data => {
    bus.$emit(EVENTS.UPDATE_REMINDER, data)
    addOrUpdateCalendarEvent(data, 'reminders')
  },
  deleteCalendarEvent: data => {
    store.commit('removeCalendarEvent', { eventPk: data.pk, type: 'calendarEvents' })
  },
  updateCalendarEvent: data => addOrUpdateCalendarEvent(data, 'reminders'),
  newCalendarEvent: data => addOrUpdateCalendarEvent(data, 'reminders'),
  deleteRdv: data => {
    store.commit('removeCalendarEvent', { eventPk: data.pk, type: 'rdvs' })
  },
  updateRdv: data => addOrUpdateCalendarEvent(data, 'rdvs'),
  newRdv: data => addOrUpdateCalendarEvent(data, 'rdvs'),
  deleteEvent: data => {
    store.commit('removeEvent', { eventPk: data.pk })
  },
  newEvent: data => {
    store.commit('addEvent', { event: data })
  },
  newOption: data => {
    store.commit('addRunningOption', { option: data })
    bus.$emit(EVENTS.NEW_OPTION, data)
    if (data.status === 'accepted' || data.status === 'waiting_list') {
      let date = moment(event.end_date)
      let key = date.format('DD/MM/YYYY')
      store.commit('addCalendarEvent', { data, key, type: 'options' })
    }
  },
  updateOption: data => {
    store.commit('updateRunningOption', { option: data })
    store.commit('removeCalendarEvent', { eventPk: data.pk, type: 'options' })
    bus.$emit(EVENTS.UPDATE_OPTION, data)
    if (data.status === 'accepted' || data.status === 'waiting_list') {
      let date = moment(data.end_date)
      let key = date.format('DD/MM/YYYY')
      store.commit('addCalendarEvent', { data, key, type: 'options' })
    }
  },
  newDenunciation: data => {
    store.commit('addRunningDenunciation', { denunciation: data })
  },
  updateDenunciation: data => {
    store.commit('updateRunningDenunciation', { denunciation: data })
  },
  updateAdvProcedure: data => {
    bus.$emit(EVENTS.UPDATE_ADV_PROCEDURE, data)
  },
  advProcedureError: data => {
    bus.$emit(EVENTS.ADV_PROCEDURE_ERROR, data)
  },
  newAdvProcedure: data => {
    bus.$emit(EVENTS.NEW_ADV_PROCEDURE, data)
  },
  newAdfLre: data => {
    bus.$emit(EVENTS.NEW_ADF_LRE, data)
  },
  updateAdfLre: data => {
    bus.$emit(EVENTS.UPDATE_ADF_LRE, data)
  },
  deleteAdfLre: data => {
    bus.$emit(EVENTS.DELETE_ADF_LRE, data)
  },
  newReminder: data => {
    addOrUpdateCalendarEvent(data, 'reminders')
    bus.$emit(EVENTS.NEW_REMINDER, data)
  }
}

export const adminRealtimeEvents = {
  newAccessBatch: data => {
    if (Number(data.total) === Number(data.done)) {
      bus.$emit(EVENTS.RELOAD, { mode: 'ACCESS', data })
    }
  },
  updateAccessBatch: data => {
    if (Number(data.total) === Number(data.done)) {
      bus.$emit(EVENTS.RELOAD, { mode: 'ACCESS', data })
    }
  }

}



// WEBPACK FOOTER //
// ./src/utils/Realtime.js